/**
 * Product branding, in one place. Change it here and every screen follows.
 *
 * NOTE — do not confuse this with the *integration* named HealNTrack (the hospital information
 * system this app exchanges orders with: `HealNTrackController`, `integration.healntrack`, the
 * `HealNTrack.Handoff` kit, `X-HealNTrack-Signature`). Those identifiers name the partner system
 * and must keep their spelling regardless of what the product is called.
 */
export const BRAND = {
  /** Full product name — page titles, login, install prompts. */
  name: "HealNTrack",
  /** Sidebar wordmark and anywhere space is tight. */
  shortName: "HealNTrack",
  /** Appended to the browser tab title. */
  productSuffix: "ERP",
  tagline: "Hospital inventory & pharmacy",
} as const;

/** "HealNTrack ERP" — the browser tab / document title. */
export const documentTitle = `${BRAND.name} ${BRAND.productSuffix}`;
